import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { getAgent, updateAgent } from "../../services/agent.service";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";

export default function AgentUpdate() {
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [agent, setAgent] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const agentID = params.get("id");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
  } = useForm();

  const fetchAgent = async () => {
    try {
      const res = await getAgent(token, agentID);
      if (res && res.status >= 200 && res.status < 300) {
        setAgent(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch agent. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching agent:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (agentID) {
      fetchAgent();
    }
  }, [agentID]);

  useEffect(() => {
    if (agent) {
      setValue("agentName", agent?.fullname);
      setValue("agentEmail", agent?.email);
      setValue("agentPhone", agent?.mobile_number);
      setValue("agentCode", agent?.user_code);
      setValue("agentAddress", agent?.agent_address);
      setValue("status", agent?.status);
    }
  }, [agent]);

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      email: item.agentEmail,
      mobile_number: item.agentPhone,
      fullname: item.agentName,
      agent_address: item.agentAddress,
      status: item.status,
      user_code: item.agentCode,
      role: "Agent",
    };

    try {
      const res = await updateAgent(token, data, agentID);
      // console.log(res);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `${item.agentName} Agent has been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
            navigate("/agent");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating main agent:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Agent</h4>
                <Link to="/agent">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Agent Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent name"
                          {...register("agentName", {
                            required: "Name is required",
                          })}
                        />
                        {errors.agentName && (
                          <p className="error">{errors.agentName.message}</p>
                        )}
                      </div>

                      {/* Status */}
                      {/* <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Status</label>
                          <i className="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={[
                            { value: "pending", label: "Pending" },
                            { value: "active", label: "Active" },
                            { value: "rejected", label: "Rejected" },
                            { value: "deactive", label: "Deactive" },
                          ]}
                          placeholder="Select status"
                          {...register("status", {
                            required: "Status is required",
                          })}
                          onChange={(selectedOption) => {
                            setValue("status", selectedOption?.value);
                            clearErrors("status");
                          }}
                          isClearable
                          value={[
                            { value: "pending", label: "Pending" },
                            { value: "active", label: "Active" },
                            { value: "rejected", label: "Rejected" },
                            { value: "deactive", label: "Deactive" },
                          ].find((option) => option.value === watch("status"))}
                        />
                        {errors.status && (
                          <p className="error">{errors.status.message}</p>
                        )}
                      </div> */}

                      {/* Agent Code */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Code</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent code"
                          maxLength={10}
                          {...register("agentCode", {
                            required: "Code is required",
                          })}
                        />
                        {errors.agentCode && (
                          <p className="error">{errors.agentCode.message}</p>
                        )}
                      </div>

                      {/* Agent Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent email"
                          {...register("agentEmail", {
                            required: "Email is required",
                          })}
                        />
                        {errors.agentEmail && (
                          <p className="error">{errors.agentEmail.message}</p>
                        )}
                      </div>

                      {/* Agent Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent phone"
                          {...register("agentPhone", {
                            required: "Phone is required",
                          })}
                        />
                        {errors.agentPhone && (
                          <p className="error">{errors.agentPhone.message}</p>
                        )}
                      </div>

                      {/* Agent Address */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">Agent Address</label>
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter agent address"
                          maxLength={200}
                          {...register("agentAddress")}
                        />
                        {errors.agentAddress && (
                          <p className="error">{errors.agentAddress.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE AGENT
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING AGENT
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
